import type { UseIntl, UserBadge } from '../../types';

import messages from './messages';

const GET_BADGES_TOOLTIPS = (intl: UseIntl) => [
  {
    originalLabel: 'Master Reflector',
    label: intl.formatMessage(messages.badgeMasterReflectorLabel),
    description: intl.formatMessage(messages.badgeMasterReflectorDesc),
  },
  {
    originalLabel: 'To New Beginnings',
    label: intl.formatMessage(messages.badgeToNewBeginningsLabel),
    description: intl.formatMessage(messages.badgeToNewBeginningsDesc),
  },
  {
    originalLabel: 'The Coach',
    label: intl.formatMessage(messages.badgeCoachLabel),
    description: intl.formatMessage(messages.badgeCoachDesc),
  },
  {
    originalLabel: 'The Watcher',
    label: intl.formatMessage(messages.badgeWatcherLabel),
    description: intl.formatMessage(messages.badgeWatcherDesc),
  },
  {
    originalLabel: 'The Quizmaster',
    label: intl.formatMessage(messages.badgeQuizmasterLabel),
    description: intl.formatMessage(messages.badgeQuizmasterDesc),
  },
  {
    originalLabel: 'The Hotspotter',
    label: intl.formatMessage(messages.badgeHotspotterLabel),
    description: intl.formatMessage(messages.badgeHotspotterDesc),
  },
];

/**
 * Retrieves either the label or description of a badge based on the specified detail type.
 *
 * @param detail - The type of detail to retrieve ('label' or 'description')
 * @param intl - The internationalization object containing translations
 * @param badge - The badge object containing the title to look up
 * @returns The requested badge detail (label or description) or an empty string if not found
 */
export const getBadgeDetail = (
  detail: 'label' | 'description',
  intl: UseIntl,
  badge: UserBadge,
) => {
  const item = GET_BADGES_TOOLTIPS(intl)
    .find(pre => pre.originalLabel === badge?.title);

  if (!item) {
    return '';
  }

  return detail === 'label' ? item.label : item.description;
};
